import { bridge } from '../../../features/extensions/instances';
import { useExtensionsSetupRegistry } from '../../../hooks/useExtensions/useExtensionsSetupRegistry';
import { useExtensionsAddPageApplet } from '../../../hooks/useExtensions/useExtensionsPageApplet';
import { useExtensionsAddTranscription } from '../../../hooks/useExtensions/useExtensionsTranscription';
import { useExtensionsAppToken } from '../../../hooks/useExtensions/useExtensionsAppToken';
import { useExtensionsFileTransfer } from '../../../hooks/useExtensions/useExtensionsFileTransfer';
import { useExtensionsFileService } from '../../../hooks/useExtensions/useExtensionsFileService';
import { useExtensionsPhotoCapture } from '../../../hooks/useExtensions/useExtensionsPhotoCapture';
import { useExtensionsFeatureFlag } from '../../../hooks/useExtensions/useExtensionsFeatureFlag';
import { useExtensionsSideloading } from '../../../hooks/useExtensions/useExtensionsSideloading';
import { useSideloadSync } from '../../../hooks/useExtensions/useSideloadSync';

export function ExtensionsMainProvider(): null {
  // Sideloading adds extensions directly to the bridge with source='sideload'
  // Registry detects sideloaded extensions by source and excludes them automatically
  useExtensionsSideloading();
  useExtensionsSetupRegistry();
  useSideloadSync();

  // provider specific init capabilities
  useExtensionsAddPageApplet();
  useExtensionsAddTranscription();
  useExtensionsAppToken(bridge);
  useExtensionsFileTransfer();
  useExtensionsFileService();
  useExtensionsPhotoCapture();
  useExtensionsFeatureFlag();

  return null;
}
